import React from "react";
import {
  useGetMyTeamMembersQuery,
  useAssignEmployeePositionMutation,
} from "../../../services/api";

export default function TeamMembersSection({ companyId, positions }) {
  const {
    data: membersData,
    isLoading,
    refetch,
  } = useGetMyTeamMembersQuery(
    { companyId },
    { skip: !companyId }
  );

  const [assignPosition, { isLoading: isAssigning }] = useAssignEmployeePositionMutation();

  const members = membersData?.members || [];

  const handlePositionChange = async (userId, positionId) => {
    try {
      await assignPosition({
        companyId,
        userId,
        positionId: positionId || null,
      }).unwrap();
      refetch();
    } catch (err) {
      console.error("Failed to assign position:", err);
    }
  };

  const getRoleBadge = (companyRole) => {
    switch (companyRole) {
      case "owner":
        return <span className="role-badge owner">Owner</span>;
      case "admin":
        return <span className="role-badge admin">Admin</span>;
      default:
        return <span className="role-badge employee">Employee</span>;
    }
  };

  return (
    <section className="team-section">
      <div className="team-section-header">
        <div>
          <h2 className="team-section-title">Team Members</h2>
          <p className="team-section-subtitle">
            View and manage your team members and their positions
          </p>
        </div>
      </div>

      {isLoading ? (
        <div className="team-members-loading">Loading team members...</div>
      ) : members.length === 0 ? (
        <div className="team-members-empty">
          No team members yet. Share your invite code to grow your team.
        </div>
      ) : (
        <table className="team-members-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            {members.map((member) => (
              <tr key={member._id}>
                <td>
                  <span className="member-name">
                    {member.firstName} {member.lastName}
                  </span>
                </td>
                <td>
                  <span className="member-email">{member.email}</span>
                </td>
                <td>{getRoleBadge(member.companyRole)}</td>
                <td>
                  <select
                    className="position-select"
                    value={member.position?._id || member.position || ""}
                    onChange={(e) => handlePositionChange(member._id, e.target.value)}
                    disabled={isAssigning}
                  >
                    <option value="">-- No Position --</option>
                    {positions.map((pos) => (
                      <option key={pos._id} value={pos._id}>
                        {pos.name}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
